export default __webpack_public_path__ + "76a819c15ac1f5ec77fb46f6974edcf7.png";